module.exports = __webpack_public_path__ + "img/bj_0.ff936190.png";